import axios from 'axios';

const api = '/api/household-types';

export const getAllHouseholdTypes = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};
